import { Fn, has, hasPath, prop } from "ramda";
import { IndexContainer } from '../../containers/IndexContainer';
import { Page } from "./Page";
type ScreenProps = any;
export interface IPageTableProps {
  title: string;
}

export const firstTruthy = (fns: Fn[], x: any) =>
  fns.reduce(
    (accumulator: any, currentFunction: Fn) =>
      accumulator || currentFunction(x),
    false
  );

export const firstTruthyMap = (fns: Fn[], x: any) =>
  [x].map((y) => firstTruthy(fns, y))[0];

export const firstProp = (keys: string[], obj: any) => {
  const result = keys.map((y) =>
    firstTruthy([(z) => (has(z, obj) ? [z, prop(z, obj)] : (false as any))], y)
  );
  return result.length > 0 ? result[0] : [];
};


const mappers = [
  (i: any) =>
    hasPath(["properties", "source", "endpoint"], i)
      ? { ...i.properties.source, url: i.endpoint }
      : false,
  (i: any) =>
    hasPath(["properties", "source", "url"], i)
      ? { ...i.properties.source }
      : false,
  (i: any) =>
    hasPath(["properties", "source"], i) ? { ...i.properties.source } : false,
  (i: any) => (hasPath(["source"], i) ? { ...i.source } : false),
  (i: any) =>
    true
      ? {
          url: "",
          key: i,
          type: "REMOTE",
        }
      : false,
];

export const PageTable: React.FC<any> = (props: ScreenProps) => {
  const {
    title,
    id,
    toolbar,
    table,
  } = props;
  return (
    <Page title={title}>
      <IndexContainer toolbar={toolbar} table={table} />
    </Page>
  );
};
